var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgScalabilityIcon = function SvgScalabilityIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#scalability_icon_svg__a)",
    d: "M11.5 23.5h27v3h-27zM34 34v4.5h-3V34h-4.5l6-6 6 6zm-15 0v4.5h-3V34h-4.5l6-6 6 6zm15-18h4.5l-6 6-6-6H31v-4.5h3zm-15 0h4.5l-6 6-6-6H16v-4.5h3z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "scalability_icon_svg__a",
    x1: 11.5,
    x2: 38.5,
    y1: 25,
    y2: 25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D52F4",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7D52F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D52F4",
    stopOpacity: 0.8
  })))));
};
export default SvgScalabilityIcon;